module.exports = __webpack_public_path__ + "static/images/containers/EloLeaderboard/components/LeaderboardTable/images/elo-icon_6.c9e22e26.png";


//////////////////
// WEBPACK FOOTER
// ./containers/EloLeaderboard/components/LeaderboardTable/images/elo-icon_6.png
// module id = 3093
// module chunks = 11